
import { defineComponent } from 'vue';
import Header from '@/components/Header/Header.vue';
import Map from './components/Map/Map.vue';
import About from './components/About/About.vue';
import Business from './components/Business/Business.vue';
import Advantage from './components/Advantage/Advantage.vue';
import Goods from './components/Goods/Goods.vue';
import Client from './components/Client/Client.vue';
import BlockTrain from './components/BlockTrain/BlockTrain.vue';
import Train from './components/Train/Train.vue';
import CargoFlight from './components/CargoFlight/CargoFlight.vue';
import TrainInformation from './components/TrainInformation/TrainInformation.vue';
import CustomsClearance from './components/CustomsClearance/CustomsClearance.vue';

export default defineComponent({
  name: 'BigScreen',
  components: {
    Header,
    Map,
    About,
    Business,
    Advantage,
    Goods,
    Client,
    BlockTrain,
    Train,
    CargoFlight,
    TrainInformation,
    CustomsClearance,
  },
  data() {
    return {
      width: 9600,
      height: 2080,
      scale: '1',
    };
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    /**
     * 重置缩放比例
     */
    resize() {
      const { innerWidth, innerHeight } = window;
      const { width, height } = this;
      const scaleX = innerWidth / width;
      const scaleY = innerHeight / height;
      this.scale = `${scaleX},${scaleY}`;
    },
  },
});
